var map = {
	"./__TypePolicies": [
		186,
		3
	],
	"./__TypePolicies.json": [
		186,
		3
	],
	"./_module_demo_/Emitters": [
		253,
		7,
		29
	],
	"./_module_demo_/Emitters.js": [
		253,
		7,
		29
	],
	"./_module_demo_/NavsAsideExtends": [
		210,
		7
	],
	"./_module_demo_/NavsAsideExtends.js": [
		210,
		7
	],
	"./_module_demo_/client/assets/images/thumbnail.jpg": [
		714,
		9,
		256
	],
	"./_module_demo_/client/graphql/item": [
		407,
		7,
		107
	],
	"./_module_demo_/client/graphql/item.js": [
		407,
		7,
		107
	],
	"./_module_demo_/client/graphql/settings": [
		202,
		7
	],
	"./_module_demo_/client/graphql/settings.js": [
		202,
		7
	],
	"./_module_demo_/client/scss/NavsAsideExtends.scss": [
		290,
		7
	],
	"./_module_demo_/client/scss/index.scss": [
		293,
		7
	],
	"./_module_demo_/client/scss/publicPage.scss": [
		689,
		7,
		175
	],
	"./_module_demo_/client/typePolicies": [
		442,
		7,
		108
	],
	"./_module_demo_/client/typePolicies.js": [
		442,
		7,
		108
	],
	"./_module_demo_/module": [
		135,
		3
	],
	"./_module_demo_/module.json": [
		135,
		3
	],
	"./_module_demo_/my/Dashboard": [
		408,
		7,
		109
	],
	"./_module_demo_/my/Dashboard.js": [
		408,
		7,
		109
	],
	"./_module_demo_/my/ModuleDemo": [
		443,
		7,
		0,
		1,
		2,
		93
	],
	"./_module_demo_/my/ModuleDemo.js": [
		443,
		7,
		0,
		1,
		2,
		93
	],
	"./_module_demo_/my/other_page": [
		444,
		7,
		110
	],
	"./_module_demo_/my/other_page.js": [
		444,
		7,
		110
	],
	"./_module_demo_/my/settings": [
		445,
		7,
		0,
		1,
		2,
		69
	],
	"./_module_demo_/my/settings.js": [
		445,
		7,
		0,
		1,
		2,
		69
	],
	"./_module_demo_/server/models": [
		255,
		7,
		3,
		26
	],
	"./_module_demo_/server/models/": [
		715,
		7,
		3,
		189
	],
	"./_module_demo_/server/models/index": [
		255,
		7,
		3,
		26
	],
	"./_module_demo_/server/models/index.js": [
		255,
		7,
		3,
		26
	],
	"./_module_demo_/server/models/modelItem": [
		376,
		7,
		3,
		111
	],
	"./_module_demo_/server/models/modelItem.js": [
		376,
		7,
		3,
		111
	],
	"./_module_demo_/server/resolvers/_Module_": [
		446,
		7,
		112
	],
	"./_module_demo_/server/resolvers/_Module_.js": [
		446,
		7,
		112
	],
	"./_module_demo_/server/resolvers/item": [
		447,
		7,
		113
	],
	"./_module_demo_/server/resolvers/item.js": [
		447,
		7,
		113
	],
	"./_module_demo_/server/resolvers/settings": [
		448,
		7,
		81
	],
	"./_module_demo_/server/resolvers/settings.js": [
		448,
		7,
		81
	],
	"./_module_demo_/server/routes": [
		256,
		7,
		4,
		6,
		21
	],
	"./_module_demo_/server/routes/": [
		716,
		7,
		4,
		6,
		171
	],
	"./_module_demo_/server/routes/demo": [
		377,
		7,
		4,
		6,
		51
	],
	"./_module_demo_/server/routes/demo.js": [
		377,
		7,
		4,
		6,
		51
	],
	"./_module_demo_/server/routes/index": [
		256,
		7,
		4,
		6,
		21
	],
	"./_module_demo_/server/routes/index.js": [
		256,
		7,
		4,
		6,
		21
	],
	"./_module_demo_/server/schema/_Module_": [
		449,
		7,
		114
	],
	"./_module_demo_/server/schema/_Module_.js": [
		449,
		7,
		114
	],
	"./_module_demo_/server/schema/item": [
		450,
		7,
		115
	],
	"./_module_demo_/server/schema/item.js": [
		450,
		7,
		115
	],
	"./_module_demo_/server/schema/settings": [
		451,
		7,
		116
	],
	"./_module_demo_/server/schema/settings.js": [
		451,
		7,
		116
	],
	"./_module_demo_/translation/en": [
		187,
		3
	],
	"./_module_demo_/translation/en.json": [
		187,
		3
	],
	"./_module_demo_/translation/it": [
		188,
		3
	],
	"./_module_demo_/translation/it.json": [
		188,
		3
	],
	"./_module_demo_/web": [
		257,
		7,
		5,
		20
	],
	"./_module_demo_/web/": [
		717,
		7,
		5,
		170
	],
	"./_module_demo_/web/PublicPage": [
		378,
		7,
		5,
		48
	],
	"./_module_demo_/web/PublicPage.js": [
		378,
		7,
		5,
		48
	],
	"./_module_demo_/web/index": [
		257,
		7,
		5,
		20
	],
	"./_module_demo_/web/index.js": [
		257,
		7,
		5,
		20
	],
	"./assistant/client/scss/index.scss": [
		201,
		7
	],
	"./assistant/client/typePolicies": [
		452,
		7,
		117
	],
	"./assistant/client/typePolicies.js": [
		452,
		7,
		117
	],
	"./assistant/client/utils": [
		148,
		7
	],
	"./assistant/client/utils/": [
		718,
		7,
		194
	],
	"./assistant/client/utils/index": [
		148,
		7
	],
	"./assistant/client/utils/index.js": [
		148,
		7
	],
	"./assistant/module": [
		136,
		3
	],
	"./assistant/module.json": [
		136,
		3
	],
	"./assistant/my/Assistant": [
		154,
		7
	],
	"./assistant/my/Assistant.js": [
		154,
		7
	],
	"./assistant/my/Dashboard": [
		409,
		7,
		118
	],
	"./assistant/my/Dashboard.js": [
		409,
		7,
		118
	],
	"./assistant/server/models": [
		258,
		7,
		3,
		27
	],
	"./assistant/server/models/": [
		719,
		7,
		3,
		190
	],
	"./assistant/server/models/index": [
		258,
		7,
		3,
		27
	],
	"./assistant/server/models/index.js": [
		258,
		7,
		3,
		27
	],
	"./assistant/server/models/modelAssistant": [
		379,
		7,
		3,
		119
	],
	"./assistant/server/models/modelAssistant.js": [
		379,
		7,
		3,
		119
	],
	"./assistant/server/resolvers/assistants": [
		410,
		7,
		104
	],
	"./assistant/server/resolvers/assistants.js": [
		410,
		7,
		104
	],
	"./assistant/server/schema/assistant": [
		453,
		7,
		120
	],
	"./assistant/server/schema/assistant.js": [
		453,
		7,
		120
	],
	"./assistant/translation/en": [
		143,
		3
	],
	"./assistant/translation/en.json": [
		143,
		3
	],
	"./assistant/translation/it": [
		144,
		3
	],
	"./assistant/translation/it.json": [
		144,
		3
	],
	"./dashboard/client/scss/index.scss": [
		294,
		7
	],
	"./dashboard/components/AllDashboards": [
		435,
		7,
		1,
		16
	],
	"./dashboard/components/AllDashboards.js": [
		435,
		7,
		1,
		16
	],
	"./dashboard/module": [
		137,
		3
	],
	"./dashboard/module.json": [
		137,
		3
	],
	"./dashboard/my/Dashboard": [
		436,
		7,
		1,
		16
	],
	"./dashboard/my/Dashboard.js": [
		436,
		7,
		1,
		16
	],
	"./dashboard/translation/en": [
		189,
		3
	],
	"./dashboard/translation/en.json": [
		189,
		3
	],
	"./dashboard/translation/it": [
		190,
		3
	],
	"./dashboard/translation/it.json": [
		190,
		3
	],
	"./kitchen-order-ticket/Emitters": [
		254,
		7,
		23
	],
	"./kitchen-order-ticket/Emitters.js": [
		254,
		7,
		23
	],
	"./kitchen-order-ticket/client/assets/images/betwixt-gestione-comande-cucina.png": [
		697,
		9,
		257
	],
	"./kitchen-order-ticket/client/assets/images/betwixt-gestione-menu-ordinabile.png": [
		698,
		9,
		258
	],
	"./kitchen-order-ticket/client/assets/images/betwixt-hours-for-reservations.png": [
		699,
		9,
		259
	],
	"./kitchen-order-ticket/client/assets/images/betwixt-order-calendar.png": [
		700,
		9,
		260
	],
	"./kitchen-order-ticket/client/assets/images/betwixt-preparation-time.png": [
		701,
		9,
		261
	],
	"./kitchen-order-ticket/client/assets/images/completed.svg": [
		702,
		9,
		199
	],
	"./kitchen-order-ticket/client/assets/images/landing-bg-top-2.jpg": [
		720,
		9,
		262
	],
	"./kitchen-order-ticket/client/assets/images/landing-bg-top.jpg": [
		721,
		9,
		263
	],
	"./kitchen-order-ticket/client/assets/images/thumbnail.jpg": [
		722,
		9,
		264
	],
	"./kitchen-order-ticket/client/assets/sounds/alert.mp3": [
		723,
		9,
		200
	],
	"./kitchen-order-ticket/client/graphql/item": [
		351,
		7,
		121
	],
	"./kitchen-order-ticket/client/graphql/item.js": [
		351,
		7,
		121
	],
	"./kitchen-order-ticket/client/graphql/settings": [
		203,
		7
	],
	"./kitchen-order-ticket/client/graphql/settings.js": [
		203,
		7
	],
	"./kitchen-order-ticket/client/scss/dashboard.scss": [
		695,
		7,
		176
	],
	"./kitchen-order-ticket/client/scss/index.scss": [
		295,
		7
	],
	"./kitchen-order-ticket/client/scss/publicPage.scss": [
		703,
		7,
		177
	],
	"./kitchen-order-ticket/client/typePolicies": [
		454,
		7,
		122
	],
	"./kitchen-order-ticket/client/typePolicies.js": [
		454,
		7,
		122
	],
	"./kitchen-order-ticket/components/ModalSliderTickets": [
		413,
		7,
		0,
		8,
		71
	],
	"./kitchen-order-ticket/components/ModalSliderTickets.js": [
		413,
		7,
		0,
		8,
		71
	],
	"./kitchen-order-ticket/components/NewTicket": [
		414,
		7,
		0,
		1,
		2,
		94
	],
	"./kitchen-order-ticket/components/NewTicket.js": [
		414,
		7,
		0,
		1,
		2,
		94
	],
	"./kitchen-order-ticket/components/OpenHours": [
		415,
		7,
		123
	],
	"./kitchen-order-ticket/components/OpenHours.js": [
		415,
		7,
		123
	],
	"./kitchen-order-ticket/components/SliderTickets": [
		380,
		7,
		0,
		8,
		76
	],
	"./kitchen-order-ticket/components/SliderTickets.js": [
		380,
		7,
		0,
		8,
		76
	],
	"./kitchen-order-ticket/components/Ticket": [
		416,
		7,
		0,
		70
	],
	"./kitchen-order-ticket/components/Ticket.js": [
		416,
		7,
		0,
		70
	],
	"./kitchen-order-ticket/components/TicketActions": [
		366,
		7,
		95
	],
	"./kitchen-order-ticket/components/TicketActions.js": [
		366,
		7,
		95
	],
	"./kitchen-order-ticket/components/TicketHistory": [
		417,
		7,
		0,
		74
	],
	"./kitchen-order-ticket/components/TicketHistory.js": [
		417,
		7,
		0,
		74
	],
	"./kitchen-order-ticket/components/TicketItems": [
		361,
		7,
		0,
		84
	],
	"./kitchen-order-ticket/components/TicketItems.js": [
		361,
		7,
		0,
		84
	],
	"./kitchen-order-ticket/module": [
		138,
		3
	],
	"./kitchen-order-ticket/module.json": [
		138,
		3
	],
	"./kitchen-order-ticket/my/Dashboard": [
		411,
		7,
		77
	],
	"./kitchen-order-ticket/my/Dashboard.js": [
		411,
		7,
		77
	],
	"./kitchen-order-ticket/my/History": [
		455,
		7,
		0,
		1,
		58
	],
	"./kitchen-order-ticket/my/History.js": [
		455,
		7,
		0,
		1,
		58
	],
	"./kitchen-order-ticket/my/KitchenOrderTicket": [
		456,
		7,
		0,
		1,
		2,
		8,
		59
	],
	"./kitchen-order-ticket/my/KitchenOrderTicket.js": [
		456,
		7,
		0,
		1,
		2,
		8,
		59
	],
	"./kitchen-order-ticket/my/settings": [
		457,
		7,
		0,
		1,
		2,
		64
	],
	"./kitchen-order-ticket/my/settings.js": [
		457,
		7,
		0,
		1,
		2,
		64
	],
	"./kitchen-order-ticket/server/models": [
		259,
		7,
		3,
		25
	],
	"./kitchen-order-ticket/server/models/": [
		724,
		7,
		3,
		174
	],
	"./kitchen-order-ticket/server/models/index": [
		259,
		7,
		3,
		25
	],
	"./kitchen-order-ticket/server/models/index.js": [
		259,
		7,
		3,
		25
	],
	"./kitchen-order-ticket/server/models/modelKOTicket": [
		381,
		7,
		3,
		124
	],
	"./kitchen-order-ticket/server/models/modelKOTicket.js": [
		381,
		7,
		3,
		124
	],
	"./kitchen-order-ticket/server/models/modelKOTicketHistory": [
		382,
		7,
		3,
		125
	],
	"./kitchen-order-ticket/server/models/modelKOTicketHistory.js": [
		382,
		7,
		3,
		125
	],
	"./kitchen-order-ticket/server/resolvers/_Module_": [
		458,
		7,
		126
	],
	"./kitchen-order-ticket/server/resolvers/_Module_.js": [
		458,
		7,
		126
	],
	"./kitchen-order-ticket/server/resolvers/item": [
		459,
		7,
		0,
		61,
		100
	],
	"./kitchen-order-ticket/server/resolvers/item.js": [
		459,
		7,
		0,
		61,
		100
	],
	"./kitchen-order-ticket/server/resolvers/settings": [
		460,
		7,
		82
	],
	"./kitchen-order-ticket/server/resolvers/settings.js": [
		460,
		7,
		82
	],
	"./kitchen-order-ticket/server/routes": [
		260,
		7,
		4,
		6,
		19
	],
	"./kitchen-order-ticket/server/routes/": [
		725,
		7,
		4,
		6,
		169
	],
	"./kitchen-order-ticket/server/routes/index": [
		260,
		7,
		4,
		6,
		19
	],
	"./kitchen-order-ticket/server/routes/index.js": [
		260,
		7,
		4,
		6,
		19
	],
	"./kitchen-order-ticket/server/routes/kot": [
		383,
		7,
		4,
		6,
		49
	],
	"./kitchen-order-ticket/server/routes/kot.js": [
		383,
		7,
		4,
		6,
		49
	],
	"./kitchen-order-ticket/server/routes/kotSettings": [
		384,
		7,
		4,
		6,
		47
	],
	"./kitchen-order-ticket/server/routes/kotSettings.js": [
		384,
		7,
		4,
		6,
		47
	],
	"./kitchen-order-ticket/server/schema/_Module_": [
		461,
		7,
		127
	],
	"./kitchen-order-ticket/server/schema/_Module_.js": [
		461,
		7,
		127
	],
	"./kitchen-order-ticket/server/schema/item": [
		462,
		7,
		128
	],
	"./kitchen-order-ticket/server/schema/item.js": [
		462,
		7,
		128
	],
	"./kitchen-order-ticket/server/schema/settings": [
		463,
		7,
		129
	],
	"./kitchen-order-ticket/server/schema/settings.js": [
		463,
		7,
		129
	],
	"./kitchen-order-ticket/server/utils/verificationDate": [
		418,
		7,
		0,
		90
	],
	"./kitchen-order-ticket/server/utils/verificationDate.js": [
		418,
		7,
		0,
		90
	],
	"./kitchen-order-ticket/translation/en": [
		191,
		3
	],
	"./kitchen-order-ticket/translation/en.json": [
		191,
		3
	],
	"./kitchen-order-ticket/translation/it": [
		192,
		3
	],
	"./kitchen-order-ticket/translation/it.json": [
		192,
		3
	],
	"./kitchen-order-ticket/web": [
		261,
		7,
		5,
		12,
		30
	],
	"./kitchen-order-ticket/web/": [
		726,
		7,
		5,
		12,
		195
	],
	"./kitchen-order-ticket/web/PublicPage": [
		419,
		7,
		5,
		12
	],
	"./kitchen-order-ticket/web/PublicPage.js": [
		419,
		7,
		5,
		12
	],
	"./kitchen-order-ticket/web/index": [
		261,
		7,
		5,
		12,
		30
	],
	"./kitchen-order-ticket/web/index.js": [
		261,
		7,
		5,
		12,
		30
	],
	"./menu-management/NavsAsideExtends": [
		211,
		7
	],
	"./menu-management/NavsAsideExtends.js": [
		211,
		7
	],
	"./menu-management/client/assets/images/Allergen_celery.svg": [
		648,
		9,
		201
	],
	"./menu-management/client/assets/images/Allergen_celery_color.svg": [
		629,
		9,
		202
	],
	"./menu-management/client/assets/images/Allergen_crustaceans.svg": [
		649,
		9,
		203
	],
	"./menu-management/client/assets/images/Allergen_crustaceans_color.svg": [
		630,
		9,
		204
	],
	"./menu-management/client/assets/images/Allergen_egg.svg": [
		650,
		9,
		205
	],
	"./menu-management/client/assets/images/Allergen_egg_color.svg": [
		631,
		9,
		206
	],
	"./menu-management/client/assets/images/Allergen_fish.svg": [
		651,
		9,
		207
	],
	"./menu-management/client/assets/images/Allergen_fish_color.svg": [
		632,
		9,
		208
	],
	"./menu-management/client/assets/images/Allergen_gluten_wheat.svg": [
		652,
		9,
		209
	],
	"./menu-management/client/assets/images/Allergen_gluten_wheat_color.svg": [
		633,
		9,
		210
	],
	"./menu-management/client/assets/images/Allergen_lupin.svg": [
		653,
		9,
		211
	],
	"./menu-management/client/assets/images/Allergen_lupin_color.svg": [
		634,
		9,
		212
	],
	"./menu-management/client/assets/images/Allergen_milk.svg": [
		654,
		9,
		213
	],
	"./menu-management/client/assets/images/Allergen_milk_color.svg": [
		635,
		9,
		214
	],
	"./menu-management/client/assets/images/Allergen_minimal_celery.svg": [
		655,
		9,
		215
	],
	"./menu-management/client/assets/images/Allergen_minimal_crustaceans.svg": [
		656,
		9,
		216
	],
	"./menu-management/client/assets/images/Allergen_minimal_egg.svg": [
		657,
		9,
		217
	],
	"./menu-management/client/assets/images/Allergen_minimal_fish.svg": [
		658,
		9,
		218
	],
	"./menu-management/client/assets/images/Allergen_minimal_gluten_wheat.svg": [
		659,
		9,
		219
	],
	"./menu-management/client/assets/images/Allergen_minimal_lupin.svg": [
		660,
		9,
		220
	],
	"./menu-management/client/assets/images/Allergen_minimal_milk.svg": [
		661,
		9,
		221
	],
	"./menu-management/client/assets/images/Allergen_minimal_mollusks.svg": [
		662,
		9,
		222
	],
	"./menu-management/client/assets/images/Allergen_minimal_mustard.svg": [
		663,
		9,
		223
	],
	"./menu-management/client/assets/images/Allergen_minimal_peanuts.svg": [
		664,
		9,
		224
	],
	"./menu-management/client/assets/images/Allergen_minimal_sesame.svg": [
		665,
		9,
		225
	],
	"./menu-management/client/assets/images/Allergen_minimal_soy.svg": [
		666,
		9,
		226
	],
	"./menu-management/client/assets/images/Allergen_minimal_sulfur_dioxide.svg": [
		667,
		9,
		227
	],
	"./menu-management/client/assets/images/Allergen_minimal_tree_nuts.svg": [
		668,
		9,
		228
	],
	"./menu-management/client/assets/images/Allergen_mollusks.svg": [
		669,
		9,
		229
	],
	"./menu-management/client/assets/images/Allergen_mollusks_color.svg": [
		636,
		9,
		230
	],
	"./menu-management/client/assets/images/Allergen_mustard.svg": [
		670,
		9,
		231
	],
	"./menu-management/client/assets/images/Allergen_mustard_color.svg": [
		637,
		9,
		232
	],
	"./menu-management/client/assets/images/Allergen_peanuts.svg": [
		671,
		9,
		233
	],
	"./menu-management/client/assets/images/Allergen_peanuts_color.svg": [
		638,
		9,
		234
	],
	"./menu-management/client/assets/images/Allergen_sesame.svg": [
		672,
		9,
		235
	],
	"./menu-management/client/assets/images/Allergen_sesame_color.svg": [
		639,
		9,
		236
	],
	"./menu-management/client/assets/images/Allergen_soy.svg": [
		673,
		9,
		237
	],
	"./menu-management/client/assets/images/Allergen_soy_color.svg": [
		640,
		9,
		238
	],
	"./menu-management/client/assets/images/Allergen_sulfur_dioxide.svg": [
		674,
		9,
		239
	],
	"./menu-management/client/assets/images/Allergen_sulfur_dioxide_color.svg": [
		641,
		9,
		240
	],
	"./menu-management/client/assets/images/Allergen_tree_nuts.svg": [
		675,
		9,
		241
	],
	"./menu-management/client/assets/images/Allergen_tree_nuts_color.svg": [
		642,
		9,
		242
	],
	"./menu-management/client/assets/images/Allergens_AF_more.svg": [
		643,
		9,
		243
	],
	"./menu-management/client/assets/images/EDC3A61041C44119.png": [
		727,
		9,
		265
	],
	"./menu-management/client/assets/images/FoodType_100_vegan.svg": [
		676,
		9,
		244
	],
	"./menu-management/client/assets/images/FoodType_biological.svg": [
		677,
		9,
		245
	],
	"./menu-management/client/assets/images/FoodType_frozen.svg": [
		678,
		9,
		246
	],
	"./menu-management/client/assets/images/FoodType_gluten_free.svg": [
		679,
		9,
		247
	],
	"./menu-management/client/assets/images/FoodType_lactose_free.svg": [
		680,
		9,
		248
	],
	"./menu-management/client/assets/images/FoodType_pulled_down.svg": [
		681,
		9,
		249
	],
	"./menu-management/client/assets/images/FoodType_spicy.svg": [
		682,
		9,
		250
	],
	"./menu-management/client/assets/images/FoodType_vegetarian.svg": [
		683,
		9,
		251
	],
	"./menu-management/client/assets/images/pp_allergens.png": [
		704,
		9,
		266
	],
	"./menu-management/client/assets/images/pp_local_with_tablet.jpg": [
		705,
		9,
		267
	],
	"./menu-management/client/assets/images/pp_menu_list.png": [
		706,
		9,
		268
	],
	"./menu-management/client/assets/images/pp_plate_detail.png": [
		707,
		9,
		269
	],
	"./menu-management/client/assets/images/pp_plates.png": [
		708,
		9,
		270
	],
	"./menu-management/client/assets/images/pp_prices_on_menus.png": [
		709,
		9,
		271
	],
	"./menu-management/client/assets/images/pp_switch.svg": [
		644,
		9,
		252
	],
	"./menu-management/client/assets/images/pp_types.png": [
		710,
		9,
		272
	],
	"./menu-management/client/assets/images/qr_double.svg": [
		645,
		9,
		253
	],
	"./menu-management/client/assets/images/qr_multiple.svg": [
		646,
		9,
		254
	],
	"./menu-management/client/assets/images/qr_single.svg": [
		647,
		9,
		255
	],
	"./menu-management/client/assets/images/thumbnail.jpg": [
		728,
		9,
		273
	],
	"./menu-management/client/graphql/assistant": [
		355,
		7,
		130
	],
	"./menu-management/client/graphql/assistant.js": [
		355,
		7,
		130
	],
	"./menu-management/client/graphql/composition": [
		349,
		7,
		105
	],
	"./menu-management/client/graphql/composition.js": [
		349,
		7,
		105
	],
	"./menu-management/client/graphql/dashboard": [
		345,
		7,
		131
	],
	"./menu-management/client/graphql/dashboard.js": [
		345,
		7,
		131
	],
	"./menu-management/client/graphql/element": [
		344,
		7,
		132
	],
	"./menu-management/client/graphql/element.js": [
		344,
		7,
		132
	],
	"./menu-management/client/graphql/facebook": [
		464,
		7,
		133
	],
	"./menu-management/client/graphql/facebook.js": [
		464,
		7,
		133
	],
	"./menu-management/client/graphql/item": [
		354,
		7,
		134
	],
	"./menu-management/client/graphql/item.js": [
		354,
		7,
		134
	],
	"./menu-management/client/graphql/menu": [
		347,
		7,
		135
	],
	"./menu-management/client/graphql/menu.js": [
		347,
		7,
		135
	],
	"./menu-management/client/graphql/settings": [
		179,
		7
	],
	"./menu-management/client/graphql/settings.js": [
		179,
		7
	],
	"./menu-management/client/scss/AllergensAndFoodType.scss": [
		684,
		7,
		178
	],
	"./menu-management/client/scss/NavsAsideExtends.scss": [
		291,
		7
	],
	"./menu-management/client/scss/QRCodePage.scss": [
		711,
		7,
		179
	],
	"./menu-management/client/scss/assistant.scss": [
		686,
		7,
		180
	],
	"./menu-management/client/scss/dashboard.scss": [
		696,
		7,
		181
	],
	"./menu-management/client/scss/index.scss": [
		296,
		7
	],
	"./menu-management/client/scss/items.scss": [
		685,
		7,
		182
	],
	"./menu-management/client/scss/landingApi.scss": [
		690,
		7,
		183
	],
	"./menu-management/client/scss/landingWidget.scss": [
		691,
		7,
		184
	],
	"./menu-management/client/scss/menuSettings.scss": [
		687,
		7,
		185
	],
	"./menu-management/client/scss/menuShare.scss": [
		692,
		7,
		186
	],
	"./menu-management/client/scss/publicPage.scss": [
		712,
		7,
		187
	],
	"./menu-management/client/scss/publicPageLanding.scss": [
		693,
		7,
		188
	],
	"./menu-management/client/scss/userPublicPage.scss": [
		713,
		7,
		192
	],
	"./menu-management/client/typePolicies": [
		465,
		7,
		136
	],
	"./menu-management/client/typePolicies.js": [
		465,
		7,
		136
	],
	"./menu-management/client/utils/assistant": [
		357,
		7,
		137
	],
	"./menu-management/client/utils/assistant.js": [
		357,
		7,
		137
	],
	"./menu-management/client/utils/item": [
		353,
		7,
		0,
		1,
		2,
		73
	],
	"./menu-management/client/utils/item.js": [
		353,
		7,
		0,
		1,
		2,
		73
	],
	"./menu-management/client/utils/tag": [
		364,
		7,
		138
	],
	"./menu-management/client/utils/tag.js": [
		364,
		7,
		138
	],
	"./menu-management/components/AllergensAndFoodType": [
		350,
		7,
		0,
		1,
		2,
		45
	],
	"./menu-management/components/AllergensAndFoodType.js": [
		350,
		7,
		0,
		1,
		2,
		45
	],
	"./menu-management/components/FormCreate": [
		370,
		7,
		0,
		1,
		2,
		7,
		65
	],
	"./menu-management/components/FormCreate.js": [
		370,
		7,
		0,
		1,
		2,
		7,
		65
	],
	"./menu-management/components/ItemRow": [
		359,
		7,
		0,
		1,
		2,
		10,
		42
	],
	"./menu-management/components/ItemRow.js": [
		359,
		7,
		0,
		1,
		2,
		10,
		42
	],
	"./menu-management/components/ItemRowEdit": [
		356,
		7,
		0,
		1,
		2,
		10,
		43
	],
	"./menu-management/components/ItemRowEdit.js": [
		356,
		7,
		0,
		1,
		2,
		10,
		43
	],
	"./menu-management/components/ItemsList": [
		385,
		7,
		0,
		1,
		2,
		10,
		41
	],
	"./menu-management/components/ItemsList.js": [
		385,
		7,
		0,
		1,
		2,
		10,
		41
	],
	"./menu-management/components/ManageTypes": [
		420,
		7,
		0,
		1,
		2,
		7,
		89
	],
	"./menu-management/components/ManageTypes.js": [
		420,
		7,
		0,
		1,
		2,
		7,
		89
	],
	"./menu-management/components/MenuDetails": [
		421,
		7,
		0,
		1,
		2,
		4,
		34
	],
	"./menu-management/components/MenuDetails.js": [
		421,
		7,
		0,
		1,
		2,
		4,
		34
	],
	"./menu-management/components/MenuDetailsEdit": [
		387,
		7,
		0,
		1,
		2,
		44
	],
	"./menu-management/components/MenuDetailsEdit.js": [
		387,
		7,
		0,
		1,
		2,
		44
	],
	"./menu-management/components/MenuDetailsHistory": [
		388,
		7,
		0,
		1,
		2,
		8,
		39
	],
	"./menu-management/components/MenuDetailsHistory.js": [
		388,
		7,
		0,
		1,
		2,
		8,
		39
	],
	"./menu-management/components/MenuDetailsItems": [
		371,
		7,
		0,
		1,
		2,
		97,
		40
	],
	"./menu-management/components/MenuDetailsItems.js": [
		371,
		7,
		0,
		1,
		2,
		97,
		40
	],
	"./menu-management/components/MenuItem": [
		391,
		7,
		0,
		1,
		2,
		85
	],
	"./menu-management/components/MenuItem.js": [
		391,
		7,
		0,
		1,
		2,
		85
	],
	"./menu-management/components/MenuSettings": [
		389,
		7,
		0,
		1,
		2,
		75
	],
	"./menu-management/components/MenuSettings.js": [
		389,
		7,
		0,
		1,
		2,
		75
	],
	"./menu-management/components/MenuShare": [
		390,
		7,
		0,
		1,
		2,
		4,
		35
	],
	"./menu-management/components/MenuShare.js": [
		390,
		7,
		0,
		1,
		2,
		4,
		35
	],
	"./menu-management/components/MenuShare_Facebook": [
		374,
		7,
		0,
		1,
		2,
		87
	],
	"./menu-management/components/MenuShare_Facebook.js": [
		374,
		7,
		0,
		1,
		2,
		87
	],
	"./menu-management/components/MenuShare_PDF": [
		373,
		7,
		0,
		1,
		2,
		4,
		36
	],
	"./menu-management/components/MenuShare_PDF.js": [
		373,
		7,
		0,
		1,
		2,
		4,
		36
	],
	"./menu-management/components/MenusList": [
		422,
		7,
		0,
		1,
		2,
		17,
		52
	],
	"./menu-management/components/MenusList.js": [
		422,
		7,
		0,
		1,
		2,
		17,
		52
	],
	"./menu-management/components/SearchForm": [
		392,
		7,
		0,
		1,
		2,
		7,
		86
	],
	"./menu-management/components/SearchForm.js": [
		392,
		7,
		0,
		1,
		2,
		7,
		86
	],
	"./menu-management/components/TagEdit": [
		386,
		7,
		0,
		1,
		2,
		139
	],
	"./menu-management/components/TagEdit.js": [
		386,
		7,
		0,
		1,
		2,
		139
	],
	"./menu-management/components/Tags": [
		358,
		7,
		0,
		1,
		2,
		7,
		96
	],
	"./menu-management/components/Tags.js": [
		358,
		7,
		0,
		1,
		2,
		7,
		96
	],
	"./menu-management/components/UserPublicPage_scripts": [
		423,
		7,
		140
	],
	"./menu-management/components/UserPublicPage_scripts.js": [
		423,
		7,
		140
	],
	"./menu-management/components/_MM_Assistant": [
		362,
		7,
		0,
		1,
		2,
		17,
		79
	],
	"./menu-management/components/_MM_Assistant.js": [
		362,
		7,
		0,
		1,
		2,
		17,
		79
	],
	"./menu-management/components/assistant/TutorialBasic": [
		363,
		7,
		0,
		1,
		2,
		72
	],
	"./menu-management/components/assistant/TutorialBasic.js": [
		363,
		7,
		0,
		1,
		2,
		72
	],
	"./menu-management/module": [
		139,
		3
	],
	"./menu-management/module.json": [
		139,
		3
	],
	"./menu-management/my/Dashboard": [
		412,
		7,
		78
	],
	"./menu-management/my/Dashboard.js": [
		412,
		7,
		78
	],
	"./menu-management/my/MenuManagement": [
		466,
		7,
		0,
		1,
		2,
		4,
		33
	],
	"./menu-management/my/MenuManagement.js": [
		466,
		7,
		0,
		1,
		2,
		4,
		33
	],
	"./menu-management/my/QRCodePage": [
		467,
		7,
		1,
		56,
		57
	],
	"./menu-management/my/QRCodePage.js": [
		467,
		7,
		1,
		56,
		57
	],
	"./menu-management/my/composition": [
		468,
		7,
		0,
		1,
		2,
		7,
		37
	],
	"./menu-management/my/composition.js": [
		468,
		7,
		0,
		1,
		2,
		7,
		37
	],
	"./menu-management/my/element": [
		469,
		7,
		0,
		1,
		2,
		7,
		38
	],
	"./menu-management/my/element.js": [
		469,
		7,
		0,
		1,
		2,
		7,
		38
	],
	"./menu-management/my/settings": [
		470,
		7,
		0,
		1,
		2,
		7,
		46
	],
	"./menu-management/my/settings.js": [
		470,
		7,
		0,
		1,
		2,
		7,
		46
	],
	"./menu-management/server/models": [
		262,
		7,
		3,
		24
	],
	"./menu-management/server/models/": [
		729,
		7,
		3,
		173
	],
	"./menu-management/server/models/index": [
		262,
		7,
		3,
		24
	],
	"./menu-management/server/models/index.js": [
		262,
		7,
		3,
		24
	],
	"./menu-management/server/models/modelComposition": [
		394,
		7,
		3,
		141
	],
	"./menu-management/server/models/modelComposition.js": [
		394,
		7,
		3,
		141
	],
	"./menu-management/server/models/modelElement": [
		395,
		7,
		3,
		142
	],
	"./menu-management/server/models/modelElement.js": [
		395,
		7,
		3,
		142
	],
	"./menu-management/server/models/modelMenu": [
		393,
		7,
		3,
		143
	],
	"./menu-management/server/models/modelMenu.js": [
		393,
		7,
		3,
		143
	],
	"./menu-management/server/resolvers/_Module_": [
		471,
		7,
		144
	],
	"./menu-management/server/resolvers/_Module_.js": [
		471,
		7,
		144
	],
	"./menu-management/server/resolvers/assistant": [
		472,
		7,
		99
	],
	"./menu-management/server/resolvers/assistant.js": [
		472,
		7,
		99
	],
	"./menu-management/server/resolvers/composition": [
		473,
		7,
		9,
		106
	],
	"./menu-management/server/resolvers/composition.js": [
		473,
		7,
		9,
		106
	],
	"./menu-management/server/resolvers/dashboard": [
		474,
		7,
		145
	],
	"./menu-management/server/resolvers/dashboard.js": [
		474,
		7,
		145
	],
	"./menu-management/server/resolvers/element": [
		426,
		7,
		9,
		146
	],
	"./menu-management/server/resolvers/element.js": [
		426,
		7,
		9,
		146
	],
	"./menu-management/server/resolvers/facebook": [
		475,
		7,
		60
	],
	"./menu-management/server/resolvers/facebook.js": [
		475,
		7,
		60
	],
	"./menu-management/server/resolvers/item": [
		476,
		7,
		9,
		147
	],
	"./menu-management/server/resolvers/item.js": [
		476,
		7,
		9,
		147
	],
	"./menu-management/server/resolvers/menu": [
		477,
		7,
		98
	],
	"./menu-management/server/resolvers/menu.js": [
		477,
		7,
		98
	],
	"./menu-management/server/resolvers/settings": [
		478,
		7,
		83
	],
	"./menu-management/server/resolvers/settings.js": [
		478,
		7,
		83
	],
	"./menu-management/server/routes": [
		263,
		7,
		4,
		6,
		13,
		31
	],
	"./menu-management/server/routes/": [
		730,
		7,
		4,
		6,
		13,
		196
	],
	"./menu-management/server/routes/index": [
		263,
		7,
		4,
		6,
		13,
		31
	],
	"./menu-management/server/routes/index.js": [
		263,
		7,
		4,
		6,
		13,
		31
	],
	"./menu-management/server/routes/mm": [
		427,
		7,
		4,
		6,
		13
	],
	"./menu-management/server/routes/mm.js": [
		427,
		7,
		4,
		6,
		13
	],
	"./menu-management/server/schema/_Module_": [
		479,
		7,
		148
	],
	"./menu-management/server/schema/_Module_.js": [
		479,
		7,
		148
	],
	"./menu-management/server/schema/assistant": [
		480,
		7,
		149
	],
	"./menu-management/server/schema/assistant.js": [
		480,
		7,
		149
	],
	"./menu-management/server/schema/composition": [
		481,
		7,
		150
	],
	"./menu-management/server/schema/composition.js": [
		481,
		7,
		150
	],
	"./menu-management/server/schema/dashboard": [
		482,
		7,
		151
	],
	"./menu-management/server/schema/dashboard.js": [
		482,
		7,
		151
	],
	"./menu-management/server/schema/element": [
		483,
		7,
		152
	],
	"./menu-management/server/schema/element.js": [
		483,
		7,
		152
	],
	"./menu-management/server/schema/facebook": [
		484,
		7,
		153
	],
	"./menu-management/server/schema/facebook.js": [
		484,
		7,
		153
	],
	"./menu-management/server/schema/item": [
		485,
		7,
		154
	],
	"./menu-management/server/schema/item.js": [
		485,
		7,
		154
	],
	"./menu-management/server/schema/menu": [
		486,
		7,
		155
	],
	"./menu-management/server/schema/menu.js": [
		486,
		7,
		155
	],
	"./menu-management/server/schema/settings": [
		487,
		7,
		156
	],
	"./menu-management/server/schema/settings.js": [
		487,
		7,
		156
	],
	"./menu-management/server/utils/AllergensAndFoodTypes": [
		182,
		3
	],
	"./menu-management/server/utils/AllergensAndFoodTypes.json": [
		182,
		3
	],
	"./menu-management/server/utils/composition": [
		424,
		7,
		157
	],
	"./menu-management/server/utils/composition.js": [
		424,
		7,
		157
	],
	"./menu-management/server/utils/element": [
		425,
		7,
		158
	],
	"./menu-management/server/utils/element.js": [
		425,
		7,
		158
	],
	"./menu-management/server/utils/item": [
		396,
		7,
		9
	],
	"./menu-management/server/utils/item.js": [
		396,
		7,
		9
	],
	"./menu-management/server/utils/menu": [
		352,
		7,
		103
	],
	"./menu-management/server/utils/menu.js": [
		352,
		7,
		103
	],
	"./menu-management/translation/en": [
		193,
		3
	],
	"./menu-management/translation/en.json": [
		193,
		3
	],
	"./menu-management/translation/it": [
		194,
		3
	],
	"./menu-management/translation/it.json": [
		194,
		3
	],
	"./menu-management/web": [
		264,
		7,
		5,
		11,
		14,
		22
	],
	"./menu-management/web/": [
		731,
		7,
		5,
		11,
		14,
		172
	],
	"./menu-management/web/LandingApi": [
		397,
		7,
		5,
		53
	],
	"./menu-management/web/LandingApi.js": [
		397,
		7,
		5,
		53
	],
	"./menu-management/web/LandingWidget": [
		398,
		7,
		5,
		54
	],
	"./menu-management/web/LandingWidget.js": [
		398,
		7,
		5,
		54
	],
	"./menu-management/web/PublicPage": [
		428,
		7,
		5,
		11
	],
	"./menu-management/web/PublicPage.js": [
		428,
		7,
		5,
		11
	],
	"./menu-management/web/PublicPageLanding": [
		399,
		7,
		5,
		55
	],
	"./menu-management/web/PublicPageLanding.js": [
		399,
		7,
		5,
		55
	],
	"./menu-management/web/UserPublicPage": [
		429,
		7,
		5,
		14,
		68
	],
	"./menu-management/web/UserPublicPage.js": [
		429,
		7,
		5,
		14,
		68
	],
	"./menu-management/web/index": [
		264,
		7,
		5,
		11,
		14,
		22
	],
	"./menu-management/web/index.js": [
		264,
		7,
		5,
		11,
		14,
		22
	],
	"./profile/client/scss/index.scss": [
		297,
		7
	],
	"./profile/module": [
		140,
		3
	],
	"./profile/module.json": [
		140,
		3
	],
	"./profile/my/Profile": [
		488,
		7,
		0,
		1,
		2,
		18,
		101
	],
	"./profile/my/Profile.js": [
		488,
		7,
		0,
		1,
		2,
		18,
		101
	],
	"./profile/translation/en": [
		195,
		3
	],
	"./profile/translation/en.json": [
		195,
		3
	],
	"./profile/translation/it": [
		196,
		3
	],
	"./profile/translation/it.json": [
		196,
		3
	],
	"./settings/client/graphql/facebook": [
		489,
		7,
		159
	],
	"./settings/client/graphql/facebook.js": [
		489,
		7,
		159
	],
	"./settings/client/scss/index.scss": [
		298,
		7
	],
	"./settings/client/typePolicies": [
		490,
		7,
		160
	],
	"./settings/client/typePolicies.js": [
		490,
		7,
		160
	],
	"./settings/components/ImageBrand": [
		430,
		7,
		0,
		1,
		2,
		10,
		161
	],
	"./settings/components/ImageBrand.js": [
		430,
		7,
		0,
		1,
		2,
		10,
		161
	],
	"./settings/components/Profile": [
		431,
		7,
		0,
		1,
		2,
		102
	],
	"./settings/components/Profile.js": [
		431,
		7,
		0,
		1,
		2,
		102
	],
	"./settings/components/RefreshPWA": [
		432,
		7,
		162
	],
	"./settings/components/RefreshPWA.js": [
		432,
		7,
		162
	],
	"./settings/module": [
		141,
		3
	],
	"./settings/module.json": [
		141,
		3
	],
	"./settings/my/Settings": [
		491,
		7,
		0,
		1,
		2,
		18,
		67
	],
	"./settings/my/Settings.js": [
		491,
		7,
		0,
		1,
		2,
		18,
		67
	],
	"./settings/server/models": [
		265,
		7,
		3,
		28
	],
	"./settings/server/models/": [
		732,
		7,
		3,
		191
	],
	"./settings/server/models/index": [
		265,
		7,
		3,
		28
	],
	"./settings/server/models/index.js": [
		265,
		7,
		3,
		28
	],
	"./settings/server/models/modelSettings": [
		400,
		7,
		3,
		163
	],
	"./settings/server/models/modelSettings.js": [
		400,
		7,
		3,
		163
	],
	"./settings/server/resolvers/facebook": [
		492,
		7,
		91
	],
	"./settings/server/resolvers/facebook.js": [
		492,
		7,
		91
	],
	"./settings/server/resolvers/settings": [
		365,
		7,
		92
	],
	"./settings/server/resolvers/settings.js": [
		365,
		7,
		92
	],
	"./settings/server/schema/facebook": [
		493,
		7,
		164
	],
	"./settings/server/schema/facebook.js": [
		493,
		7,
		164
	],
	"./settings/server/schema/settings": [
		494,
		7,
		165
	],
	"./settings/server/schema/settings.js": [
		494,
		7,
		165
	],
	"./settings/translation/en": [
		197,
		3
	],
	"./settings/translation/en.json": [
		197,
		3
	],
	"./settings/translation/it": [
		198,
		3
	],
	"./settings/translation/it.json": [
		198,
		3
	],
	"./shop/client/assets/images/stripe-logo.png": [
		694,
		9,
		274
	],
	"./shop/client/scss/CardSectionStyles.scss": [
		688,
		7,
		193
	],
	"./shop/client/scss/index.scss": [
		299,
		7
	],
	"./shop/client/utils": [
		266,
		7,
		32
	],
	"./shop/client/utils/": [
		733,
		7,
		197
	],
	"./shop/client/utils/index": [
		266,
		7,
		32
	],
	"./shop/client/utils/index.js": [
		266,
		7,
		32
	],
	"./shop/components/CardSection": [
		375,
		7,
		88
	],
	"./shop/components/CardSection.js": [
		375,
		7,
		88
	],
	"./shop/components/Checkout": [
		433,
		7,
		0,
		1,
		2,
		15,
		66
	],
	"./shop/components/Checkout.js": [
		433,
		7,
		0,
		1,
		2,
		15,
		66
	],
	"./shop/components/CheckoutForm": [
		401,
		7,
		0,
		1,
		2,
		15,
		80
	],
	"./shop/components/CheckoutForm.js": [
		401,
		7,
		0,
		1,
		2,
		15,
		80
	],
	"./shop/components/ModuleItem": [
		402,
		7,
		0,
		1,
		2,
		63
	],
	"./shop/components/ModuleItem.js": [
		402,
		7,
		0,
		1,
		2,
		63
	],
	"./shop/components/ModuleList": [
		434,
		7,
		0,
		1,
		2,
		62
	],
	"./shop/components/ModuleList.js": [
		434,
		7,
		0,
		1,
		2,
		62
	],
	"./shop/module": [
		142,
		3
	],
	"./shop/module.json": [
		142,
		3
	],
	"./shop/my/Shop": [
		495,
		7,
		0,
		1,
		2,
		15,
		50
	],
	"./shop/my/Shop.js": [
		495,
		7,
		0,
		1,
		2,
		15,
		50
	],
	"./shop/translation/en": [
		199,
		3
	],
	"./shop/translation/en.json": [
		199,
		3
	],
	"./shop/translation/it": [
		200,
		3
	],
	"./shop/translation/it.json": [
		200,
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 590;
module.exports = webpackAsyncContext;